<template>
  <div
    class="p-the-a05-point-notification-panel-thanks"
    :style="{ background: colorCode }"
  >
    <div class="p-the-a05-point-notification-panel-thanks__header">
      <div class="p-the-a05-point-notification-panel-thanks__image">
        <img
          v-if="hasBadge"
          :src="badgeIcon"
          class="p-the-a05-point-notification-panel-thanks__badge-image"
        >
        <IconNotificationThanks
          v-else
          :icon-size="62"
        />
      </div>
      <div class="p-the-a05-point-notification-panel-thanks__summary">
        <div
          v-if="hasBadge"
          class="p-the-a05-point-notification-panel-thanks__badge-name"
          data-translate-skip
        >
          {{ badgeName }}
        </div>
        <div
          class="p-the-a05-point-notification-panel-thanks__title"
          data-translate-skip
        >
          {{ title }}
        </div>
      
      </div>
    </div>
    <div class="p-the-a05-point-notification-panel-thanks__message" data-translate-skip>
      {{ message }}
    </div>
    <div class="p-the-a05-point-notification-panel-thanks__footer">
      <span class="p-the-a05-point-notification-panel-thanks__point-badge" data-translate-skip>
        {{ addComma(point) }} {{ unit.point }}
      </span>
    </div>
  </div>
</template>

<script lang="ts">
import IconNotificationThanks from "@/common/components/icons/IconNotificationThanks.vue";
import globals from "@/general/store/modules/globals";
import commons from "@/common/store/modules/commons";
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    title: { type: String, required: true },
    point: { type: Number, required: false },
    message: { type: String, required: false },
    badgeIcon: { type: String, default: null },
    badgeName: { type: String,default: null }
  },
  components: {
    IconNotificationThanks
  }
})
export default class TheJ05NotificationPanelThanks extends Vue {
  title!: string;
  unit = commons.unit;
  point!: number;
  message!: string;
  badgeIcon!: string | null;
  badgeName!: string | null;

  addComma(value: any) {
    const number = Number(value);
    if (Number.isNaN(number)) {
      return value;
    }
    return number.toLocaleString();
  }

  get colorCode() {
    return "#f6bebe";
  }

  get hasBadge() {
    return !!this.badgeIcon && !!this.badgeName;
  }
}
</script>

<style lang="scss" scoped>
.p-the-a05-point-notification-panel-thanks {
  border-radius: rem(20);
  border: 1px solid $common-gray300;
  overflow: hidden;
  padding: rem(12);

  &__header {
    display: flex;
    align-items: center;
  }
  &__image {
    flex-shrink: 0;

    @include pc {
      width: rem(60);
      margin-right: rem(16);
    }
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__summary {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: left;
  }
  @include pc {
    //    background-image: url("/assets/img/common/background/hanafubuki.png");
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
  }

  &__title {
    word-break: break-all;
    white-space: pre-line;
    font-weight: 500;
    color: #9c5050;
    text-align: left;
    line-height: 1.2;
    font-size: rem(16);

    @include pc {
      line-height: 1.4;
    }

  }
}
.p-the-a05-point-notification-panel-thanks__message {
  margin-top: rem(6);
  color: #9c5050;
  white-space: pre-line;
  line-height: 1.8;
  font-weight: 500;

  @include pc {
    font-size: rem(14);
  }

  @include sp {
    font-size: rem(11);
  }
}

.p-the-a05-point-notification-panel-thanks__footer {
  margin-top: rem(4);
  text-align: center;
}
.p-the-a05-point-notification-panel-thanks__point-badge {
  display: inline-flex;

  align-items: center;
  justify-content: center;

  min-width: rem(140);

  padding: rem(6) rem(20);

  background: #ffffff;

  border-radius: rem(999);

  color: #9c5050;

  font-weight: 700;

  box-shadow: 0 2px 4px rgba(0, 0, 0, .1);
}
.p-the-a05-point-notification-panel-thanks {

  &__badge-image {
    width: rem(62);
    height: rem(62);
    object-fit: contain;

    @include sp {
      margin-right: rem(16);
    }
  }

  &__badge-name {
    width: fit-content;
    align-self: flex-start;
    margin-bottom: rem(8);
    padding: rem(4) rem(12);
    border-radius: rem(16);
    background: #fff;
    color: #9c5050;
    font-size: rem(12);
    font-weight: 700;
  }
}
</style>
